module.exports = __webpack_public_path__ + "static/media/source-point.e68c6e65.svg";